import { useAtom } from 'jotai';
import { progressBarValueAtom, recaptchaTokenAtom } from 'shared/state/atoms';

export const useRecaptchaTokenAtom = () => useAtom(recaptchaTokenAtom);

export const useProgressBarValue = () => useAtom(progressBarValueAtom);
